export default __webpack_public_path__ + "static/media/css.ad2a9af5.png";